<template>
  <section class="header_box">
    <section class="index_header">
      <section class="header_top">
        <section class="market_box" @click="toSelectMarket">
          <img v-if="!common.cityId" class="hi" :src="require(`../../../assets/images/icon_hi_${$store.state.common.theme}.png`)" />
          <img v-else class="location" :src="require(`../../../assets/images/icon_location_${$store.state.common.theme}.png`)" />
          <span>{{marketInfo.marketName}}</span>
          <img v-if="common.cityId" class="arrow" :src="require(`../../../assets/images/icon_arrows_filter_${$store.state.common.theme}.png`)" />
        </section>
        <section class="login" @click="toLogin" v-if="!common.userId">
          <button>登录</button>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: "indexHeader",
  props: {
    common:{
      type:Object,
      default:()=>{return {}}
    },
    marketInfo: Object
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    toLogin() {
      if (!this.userId) {
        this.$router.push(`/login`);
      } else {
        this.$router.push(`/me`);
      }
    },
    toSelectMarket() {
      if(this.common.cityId){
        this.$router.push(`/selectMarket`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.index_header {
  height: 1.08rem;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // z-index:100;
  background:#fff;
  // box-shadow: 0px 0px .18rem 0px rgba(0, 0, 0, 0.05);
  .header_top {
    padding: 0 0.28rem;
    height: 1.08rem;
    .flex();
    justify-content: space-between;
    align-items: center;
  }
  .market_box {
    height: 1.08rem;
    .flex();
    align-items: center;
    .hi {
      display: block;
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.14rem;
    }
    .location{
      display: block;
      width: 36px;
      height: 36px;
      margin-right: 0.14rem;
    }
    .arrow{
      display: block;
      width: 24px;
      height: 24px;
      margin-left:12px;
    }
    span {
      display: block;
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      .textOver(420px);
      height:1.08rem;
      line-height:1.08rem;
    }
  }
  .login{
    button{
      width:1.2rem;
      height:0.52rem;
      border-radius:0.04rem;
      border:0.02rem solid rgba(23,64,218,1);
      text-align:center;
      line-height: 0.52rem;
      font-size:.24rem;
      color:@color17;
      box-sizing: border-box;
    }
  }
}
.swiper_box{
  padding:0 .2rem;
  background:#fff;
  height:2.9rem;
  padding-top:1.08rem;
}
.swiper_h{
}
</style>
